import { SUCCESS, FETCH_SCAN_NOTES_PERMISSIONS } from '../constants/actionApi';
import initialState from '../store/initialState';
import { updateObjectInState } from '../helpers/data';

export default (state = initialState.scanNotesPermissions, { type, payload }) => {
  switch (type) {
    case FETCH_SCAN_NOTES_PERMISSIONS + SUCCESS:
      return updateObjectInState(state, payload.data);
    default:
      return state;
  }
};
